import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import AuthStore from '../../store/AuthStore';
import PersonIcon from '@mui/icons-material/Person';
import shortLogo from '../../assets/images/shortLogo.png';
import {
  Badge,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  SwipeableDrawer,
  styled,
} from '@mui/material';
import {
  AddAPhoto,
  AddOutlined,
  AllInclusive,
  CameraAlt,
  Edit,
  ExpandLess,
  ExpandLessOutlined,
  ExpandMore,
  Logout,
  ManageAccounts,
  Person,
  Schema,
  Settings,
  Task,
} from '@mui/icons-material';
import UserStore from '../../store/UserStore';
import { BrowseProfilePictureDialog } from '../BrowseProfilePictureDialog';
import { NewPipelineDialog } from '../NewPipelineDialog';

export const UserSettingsDrawer = observer(({ toggleUserSettingsDrawer, handleUserSettingsDrawer }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    AuthStore.logout();
  };

  const drawerWidth = 240;

  const [toggleConfigurations, setToggleConfigurations] = useState(false);
  const handleToggleConfigurationSubItems = () => {
    setToggleConfigurations(!toggleConfigurations);
  };

  const [isNewPipeline, setIsNewPipelines] = useState(false);
  const [togglePipelines, setTogglePipelines] = useState(false);
  const handleTogglePipelineSubItems = () => {
    setTogglePipelines(!togglePipelines);
  };

  const [toggleBrowseProfilePictureDialog, setToggleBrowseProfilePictureDialog] = useState(false);
  const handleBrowseProfilePictureDialog = () => {
    setToggleBrowseProfilePictureDialog(!toggleBrowseProfilePictureDialog);
  };

  const [toggleNewPipelineDialog, setToggleNewPipelineDialog] = useState(false);
  const handleNewPipelineDialog = (isNew = true) => {
    setIsNewPipelines(isNew);
    setToggleNewPipelineDialog(!toggleNewPipelineDialog);
  };

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 36,
    height: 36,
    border: `2px solid ${theme.palette.background.paper}`,
    backgroundColor: '#4c3a22',
  }));

  return (
    <>
      <SwipeableDrawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
          },
        }}
        anchor="right"
        open={toggleUserSettingsDrawer}
        onOpen={() => {}}
        onClose={handleUserSettingsDrawer}
      >
        {/* <DrawerHeader>
          <IconButton onClick={handleUserSettingsDrawer}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
          <Button sx={{color: 'rgba(0, 0, 0, 0.54)'}} endIcon={<LogoutIcon />} onClick={handleLogout}>
            Logout
          </Button>
        </DrawerHeader> */}
        <Stack sx={{ py: '10px' }} alignItems={'center'}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              <IconButton onClick={handleBrowseProfilePictureDialog}>
                <SmallAvatar alt="Remy Sharp">
                  <AddAPhoto sx={{ height: '24px', width: '24px' }}></AddAPhoto>
                </SmallAvatar>
              </IconButton>
            }
          >
            {UserStore.userImage ? (
              <Avatar
                alt={AuthStore.userDetails.Name}
                sx={{ width: 110, height: 110 }}
                src={UserStore.userImage}
              ></Avatar>
            ) : (
              <Avatar alt={AuthStore.userDetails.Name} sx={{ width: 110, height: 110 }}>
                <Person sx={{ fontSize: 82 }}></Person>
              </Avatar>
            )}
          </Badge>
        </Stack>
        <List>
          {AuthStore.userDetails.Role.toUpperCase() === 'SUAD' ? (
            <>
              <ListItem disablePadding>
                <ListItemButton onClick={() => navigate('/user-management')}>
                  <ListItemIcon>
                    <ManageAccounts />
                  </ListItemIcon>
                  <ListItemText primary={'User Management'} />
                </ListItemButton>
              </ListItem>
              <Divider />
              <ListItem disablePadding>
                <ListItemButton onClick={handleTogglePipelineSubItems}>
                  <ListItemIcon>
                    <AllInclusive />
                  </ListItemIcon>
                  <ListItemText primary={'Pipeline'} />
                  {togglePipelines ? <ExpandLessOutlined /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
              <Collapse in={togglePipelines} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} onClick={handleNewPipelineDialog}>
                    <ListItemIcon>
                      <AddOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Create Pipeline" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} onClick={() => handleNewPipelineDialog(false)}>
                    <ListItemIcon>
                      <Edit />
                    </ListItemIcon>
                    <ListItemText primary="Edit Pipeline" />
                  </ListItemButton>
                </List>
              </Collapse>
              <Divider />
              {/* <ListItem disablePadding>
                      <ListItemButton onClick={handleToggleConfigurationSubItems}>
                        <ListItemIcon>
                          <Settings />
                        </ListItemIcon>
                        <ListItemText primary={'Configuration'} />
                        {toggleConfigurations ? <ExpandLessOutlined /> : <ExpandMore />}
                      </ListItemButton>
                    </ListItem>
                    <Collapse in={toggleConfigurations} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        <ListItemButton sx={{ pl: 4 }}>
                          <ListItemIcon>
                            <Task />
                          </ListItemIcon>
                          <ListItemText primary="Task Priority" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} onClick={() => navigate('/workflow-stages')}>
                          <ListItemIcon>
                            <Schema />
                          </ListItemIcon>
                          <ListItemText primary="Workflow Stages" />
                        </ListItemButton>
                      </List>
                    </Collapse>
                    <Divider /> */}
            </>
          ) : (
            ''
          )}
          <ListItem disablePadding>
            <ListItemButton onClick={handleLogout}>
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              <ListItemText primary={'Logout'} />
            </ListItemButton>
          </ListItem>
          <Divider />
        </List>
      </SwipeableDrawer>
      <BrowseProfilePictureDialog
        toggleDialog={toggleBrowseProfilePictureDialog}
        handleDialog={handleBrowseProfilePictureDialog}
      ></BrowseProfilePictureDialog>
      <NewPipelineDialog
        toggleDialog={toggleNewPipelineDialog}
        handleDialog={handleNewPipelineDialog}
        isNew={isNewPipeline}
      ></NewPipelineDialog>
    </>
  );
});
